module.exports = __webpack_public_path__ + "cy.svg?dbf92cb89053f06b273f767cc7dd3a8e";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/cy.svg
// module id = 1319
// module chunks = 0